import { render, staticRenderFns } from "./PromoList.vue?vue&type=template&id=1a690fd8"
import script from "./PromoList.vue?vue&type=script&lang=js"
export * from "./PromoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports